module.exports = __webpack_public_path__ + "assets/images/2cfda0b921b26f154472c84c00bc359c.png";